import SwiperCore, { Navigation } from 'swiper/core';
import Swiper from 'swiper';
import { Breakpoint } from '../types/breakpoint';
export default class FlavourVariantsSlider {
    static $slider = $('.js__flavour-variants-slider');
    static swiper;
    static options = {
        centeredSlides: true,
        slidesPerView: 1,
        centerInsufficientSlides: true,
        spaceBetween: 24,
        watchOverflow: false,
        allowTouchMove: false,
        breakpoints: {
            [Breakpoint.lg]: {
                slidesPerView: 6,
                spaceBetween: 0,
                centeredSlides: false,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        this.$slider.each((index, element) => {
            SwiperCore.use([Navigation]);
            this.swiper = new Swiper($(element).get(0), {
                ...this.options,
                navigation: {
                    nextEl: `.js__swiper-button-next-${index}`,
                    prevEl: `.js__swiper-button-prev-${index}`,
                },
            });
        });
    }
}
